export const IONISE_MEDIUM_URL = "https://medium.com/@ionise_protocol";
// export const IONISE_DISCORD_URL = "https://discord.com/invite/pTQ9EBHYtF";
export const IONISE_TWITTER_URL = "https://twitter.com/ionise_protocol";
// export const IONISE_GITHUB_URL = "https://github.com/VenusProtocol/";
